import Calendar from './calendar';

const minDateStr = `${Calendar.minDate.getFullYear()}/${('0' + (Calendar.minDate.getMonth() + 1)).slice(-2)}/${('0' + Calendar.minDate.getDate()).slice(-2)}`;
const maxDateStr = `${Calendar.maxDate.getFullYear()}/${('0' + (Calendar.maxDate.getMonth() + 1)).slice(-2)}/${('0' + Calendar.maxDate.getDate()).slice(-2)}`;

const validationPattern = {
    num4: {
        pattern: /^\d{4}$/,
        message: `は4桁の半角数字で入力してください。`
    },
    num7: {
        pattern: /^\d{1,7}$/,
        message: `は7桁以内の半角数字で入力してください。`
    },
    date: {
        pattern: /^\d{4}\/\d{2}\/\d{2}$/,
        message: `は ${minDateStr} ～ ${maxDateStr} の日付で入力してください。`
    },
    select: {
        pattern: /^.+$/,
        message: `が選択されていません。`
    }
};

const requireMessage = "が入力されていません。";

export default class Validator {

    /**
     * パターン評価
     * NGならエラーメッセージ、OKならfalse
     * @param {string} type
     * @param {string} value
     * @param {string} title
     * @returns {boolean|string}
     */
    static testPattern(type, value, title) {
        let result = false;

        switch (type) {
            case 'date':
                let inputDate = new Date(value);
                let isOutOfDate = inputDate < Calendar.minDate || inputDate > Calendar.maxDate;

                if (isOutOfDate || !value.match(validationPattern[type].pattern)) {
                    result = title + validationPattern[type].message;
                }

                break;
            default:
                let testResult = value.match(validationPattern[type].pattern);
                if (!testResult) result = title + validationPattern[type].message;
        }

        return result;
    }

    /**
     * 値がなければエラーメッセージ
     * @param {string} value
     * @param {string} title
     * @returns {boolean|string}
     */
    static testRequire(value, title = '') {
        let result = false;
        if (value === "") result = title + requireMessage;
        return result;
    }
}
